module.exports = __webpack_public_path__ + "img/Body-block.6ace4b3e.png";